import { useState, useEffect } from 'react';

/**
 * Hook to handle scroll effects like fixed header
 * @param {number} threshold - Scroll threshold in pixels to trigger the effect
 * @returns {boolean} - Whether the scroll position is past the threshold
 */
const useScrollEffect = (threshold = 50) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth >= 1200) { // Matching media query in original jQuery
        setIsScrolled(window.scrollY >= threshold);
      }
    };

    // Add event listener
    window.addEventListener('scroll', handleScroll);

    // Call handler right away to check initial scroll position
    handleScroll();

    // Clean up
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  return isScrolled;
};

export default useScrollEffect;
